import { useModeAwareQuery } from "./useModeAwareQuery";
import { useApi } from "./useApi";
import { getGlobalDataStore } from "@/lib/mock-data/global-data-store";

export interface UnallocatedPaymentsSummaryApi {
  unallocatedCount: number;
  totalOutstandingAmount: number;
}

/**
 * Hook to fetch unallocated payments summary.
 * In live mode, calls GET /api/v1/receipts/unallocated-summary.
 * In demo mode, returns data derived from the global data store.
 */
export function useUnallocatedPaymentsSummary() {
  const { apiGet } = useApi();

  const store = getGlobalDataStore();
  const unallocatedReceipts = store.getUnallocatedReceipts();
  const demoData: UnallocatedPaymentsSummaryApi = {
    unallocatedCount: unallocatedReceipts.length,
    totalOutstandingAmount: unallocatedReceipts.reduce(
      (sum, r) => sum + r.unappliedAmount,
      0
    ),
  };

  return useModeAwareQuery<UnallocatedPaymentsSummaryApi, Error>(
    ["unallocated-payments-summary"],
    async ({ signal }) => {
      return apiGet<UnallocatedPaymentsSummaryApi>(
        "/api/v1/receipts/unallocated-summary",
        undefined,
        signal
      );
    },
    demoData,
    { staleTime: 0, refetchOnMount: "always", refetchOnWindowFocus: false }
  );
}
